import React from "react";
import ReactDOM from "react-dom";
import FindOffice from "./FindOffice.jsx";

const safeParse = (str, fallback) => {
  if (!str) return fallback;
  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
};

/**
 * Mounts the FindOffice component into every element with the .js-find-office-mount class.
 * Accepts props from HTML in two ways:
 *  1) data-props='{"bannerProps": {...}, "paginationProps": {...}}'
 *  2) data-banner-props='{}' and data-pagination-props='{}'
 */
export function renderFindOffice() {
  document.querySelectorAll(".js-find-office-mount").forEach((mount, i) => {
    if (mount.dataset.mounted === "true") return;

    const mergedProps = safeParse(mount.dataset.props, null) ?? {
      bannerProps: safeParse(mount.dataset.bannerProps, undefined),
      paginationProps: safeParse(mount.dataset.paginationProps, undefined),
      defaultFormProps: safeParse(mount.dataset.defaultFormProps, undefined)
    };

    ReactDOM.render(
      <FindOffice {...mergedProps} key={`find-office-${i}`} />,
      mount
    );

    mount.dataset.mounted = "true";
  });
}
